import React, { useEffect, useState } from 'react';
import { ImageMedia } from './MediaItems.styles';
import { Skeleton } from '@material-ui/lab';

interface Props {
  src: string;
}

const ImageItem: React.FC<Props> = ({ src }) => {
  const [isImageLoaded, setisImageLoaded] = useState(false);

  //useEffect to check if image is loaded
  useEffect(() => {
    const img: HTMLImageElement = new Image();
    img.src = src;
    img.onload = () => {
      setisImageLoaded(true);
    };
  }, [src]);

  return isImageLoaded ? (
    <ImageMedia src={src} alt="opportunities image" onClick={() => window.open(src, '_blank')} />
  ) : (
    <Skeleton variant="rect" width={50} height={80} />
  );
};

export default ImageItem;
